import React, { useRef, useState, useEffect } from 'react';
import Cropper from 'react-cropper';
import Loader from '../Loader/Loader';
import SliderHeader from 'jd-library/SliderHeader';
import { getImagePath , onFileSelUpload } from '../productImageUtils';
import './style.scss';
import { deleteProductImage, toggleEditOptions, updateProductMedia } from '../../actions/products';
import { connect } from 'react-redux';
import toastMessageActions from 'jd-library/toastMessageActions';
import Tag from 'jd-library/Tag';

const validImageTypes = ["jpeg", "png", "jpg", "webp"];
var validationError = "Please Upload Images With ";
for (var i = 0; i < validImageTypes.length; i++) {
    var curr = validImageTypes[i];
    if (i < validImageTypes.length - 1) {
        validationError += i != 0 ? (", " + curr.toUpperCase()) : curr.toUpperCase();
    } else {
        validationError += " or " + curr.toUpperCase();
    }
}
validationError += " Format";

var rotateDeg = 0;

const ImageCropper = props => {
    const curCropperData = props.data[0];
    const [isCropperReady,toggleCropperReady] = useState(false);
    const [croppedImage,updateCroppedImage] = useState('');
    const [cropperHW,updateCropperHW] = useState({
        height: 0,
        width: 0
    })
    const [showCropper,toggleCropper] = useState(false);
    const [isInteracted, updatedInteraction] = useState(false);
    const [showLoader,toggleLoader] = useState(true);
    const [imageHeightWidth, updateImageHeightWidth] = useState({
        imageWidth: curCropperData.imageWidth || 0,
        imageHeight: curCropperData.imageHeight || 0,
        rotate: 0
    })
    const [popoverPos,setPopoverPos] = useState(props.isMobile? {} : {top: 0,bottom: 0})
    let reactCropper = useRef(null);
    let zoomRatio = useRef(1);
    // const [zoomRatio,updateZoomRatio] = useState(1);
    
    const setCropBoxInCenter = curCropperData.setCropBoxInCenter;
    const extension = curCropperData.extension || curCropperData.src.split('.').pop().toLowerCase();
    const uploadFrom = curCropperData.uploadFrom || '';
    const fixedCropBoxSize = curCropperData.fixedCropBoxSize || false;
    const src = curCropperData.src;
    const prefWidth = curCropperData.prefWidth || 0;
    const prefHeight = curCropperData.prefHeight || 0;
    const items = [
        {
            key: 'crop',
            hoverText: 'Crop',
            iconClass: 'icon-crop',
            onClick: (event) => {
                const curTarget = event.currentTarget;
                curTarget.style.background = '#000';
                setTimeout(() => {
                    curTarget.style.background = '#2A2C2E';
                }, 100);
                let {width,height,left,top,naturalHeight,naturalWidth} = reactCropper.getCanvasData();
                toggleCropper(true);
                updateCropperHW({
                    height: naturalHeight,
                    width: naturalWidth
                })
                if(!props.isMobile) {
                    updatedInteraction(true);
                }else if(props.isMobile){
                    if(croppedImage.image) {
                        updateCroppedImage({
                            ...croppedImage,
                            image: croppedImage.oldImage,
                            newImage: reactCropper.getCroppedCanvas().toDataURL()
                        })
                        setTimeout(() => {
                            let aspectRatio = reactCropper.canvasData.aspectRatio;
                            reactCropper.setCropBoxData({...croppedImage.cnvsPos});
                            reactCropper.setCanvasData({...croppedImage.cnvsPos})
                            let canvasData = reactCropper.getCanvasData();
                            let {left,top,height,width} = croppedImage.Pos;
                            if(rotateDeg) {
                                let containerData = reactCropper.getContainerData();
                                let canvasLeft = canvasData.left,
                                canvasTop = canvasData.top,
                                canvasWidth = [90,270].includes(rotateDeg) ? canvasData.height : canvasData.width,
                                canvasHeight = [90,270].includes(rotateDeg) ? canvasData.width : canvasData.height;
                                canvasLeft = (containerData.width - canvasWidth) / 2;
                                canvasTop = (containerData.height - canvasHeight) / 2;
                                reactCropper.setCropBoxData({
                                    height:canvasHeight,width:canvasWidth,left:canvasLeft,top: canvasTop
                                })
                                reactCropper.rotate(rotateDeg);
                                let oldHeight = height,
                                oldTop = top,
                                oldLeft = left;
                                switch(rotateDeg) {
                                    case 90: {
                                        height = width;
                                        width = oldHeight;
                                        top = reactCropper.canvasData.top + (oldLeft - canvasData.left);
                                        left = reactCropper.canvasData.left + (reactCropper.canvasData.width - (width + (oldTop - canvasData.top)))
                                    }
                                    break;
                                    case 180: {
                                        top = reactCropper.canvasData.top + (reactCropper.canvasData.height - ((oldTop - canvasData.top) + height));
                                        left = reactCropper.canvasData.left + (reactCropper.canvasData.width - ((oldLeft - canvasData.left) + width))
                                    }
                                    break;
                                    case 270: {
                                        height = width;
                                        width = oldHeight;
                                        top = reactCropper.canvasData.top + (reactCropper.canvasData.height - (height + (oldLeft - canvasData.left)));
                                        left = reactCropper.canvasData.left + (oldTop - canvasData.top)
                                    }
                                    
                                }
                            }
                            updateCropperHW({
                                height,
                                width
                            })
                            reactCropper.setCropBoxData({
                                height,width,top,left
                            })
                        }, 300);
                    }else {
                        let image = reactCropper.getCroppedCanvas().toDataURL();
                        updateCroppedImage({
                            ...croppedImage,
                            oldImage: image
                        })
                    }
                }
                reactCropper.setCropBoxData({
                    left: left,
                    top: top,
                    width: width,
                    height: height
                })
            }
        },
        {
            key: 'rotate',
            hoverText: "Rotate",
            iconClass: 'icon-rotate',
            onClick : (event,value) => {
                const curTarget = event.currentTarget;
                curTarget.style.background = '#000';
                setTimeout(() => {
                    curTarget.style.background = '#2A2C2E';
                }, 100);
                let rotate = (imageHeightWidth + 90) == 360 ? 0 : imageHeightWidth.rotate + 90;
                let {width,height,left,top,naturalHeight,naturalWidth} = reactCropper.getCanvasData();
                updateCropperHW({
                    height: naturalWidth,
                    width: naturalHeight
                })
                let containerData = reactCropper.getContainerData();    
                let oldWidth = width;
                let oldHeight = height;
                width = height
                height = oldWidth;
                let aspectRatio = reactCropper.canvasData.aspectRatio;
                if(width > height) {
                    width = width >= containerData.width ? containerData.width * 0.8 : width;
                    height = width * aspectRatio;
                }else if(height > width){
                    height = height >= (containerData.height * 0.8) ? containerData.height * 0.8 : height;
                    width = height / aspectRatio
                }
                left = (containerData.width - width) / 2;
                top = (containerData.height - height) / 2;
                reactCropper.setCropBoxData({
                    height,width,left,top
                })
                reactCropper.rotate(90);
                
                reactCropper.setCanvasData({
                    height,width,left,top
                })
                reactCropper.setCropBoxData({
                    height,width,
                    left: (left + (oldWidth / 2)) - (width / 2),
                    top: (top + (oldHeight / 2)) - (height / 2)
                })
                rotateDeg = croppedImage.image ? (rotateDeg + 90 < 360 ? rotateDeg + 90 : 0) : 0;
                updateImageHeightWidth({
                    ...imageHeightWidth,
                    rotate:  rotate
                })
            }
        },
        {
            key: 'enhance',
            hoverText: props.isMobile ? <>Enhance <span className="tagClass"><Tag type={'success'} children='Coming Soon' /></span></> : 'Enhance (Coming Soon)',
            iconClass: 'icon-magicWand',
        }, {
            key: 'removeBg',
            hoverText: props.isMobile? <>Remove BG <span className="tagClass"><Tag type={'success'} children='Coming Soon' /></span></>: 'Remove BG (Coming Soon)',
            iconClass: 'icon-Change-Image',
        }
    ]
    const fitInScreen = (height,width,containerData,aspectRatio) => {
        if(height >= width) {
            height = height >= (containerData.height * 0.75) ? containerData.height * 0.75 : height;
            width = height * aspectRatio;
            if(height >= (containerData.width * 0.9)) {
                return fitInScreen(height - 20,width,containerData,aspectRatio);
            }
        }else if(width > height) {
            width = width >= containerData.width ? containerData.width * 0.8 : width;
            height = width / aspectRatio;
            if(width > (containerData.height * 0.75)) {
                return fitInScreen(height,width - 20,containerData,aspectRatio);
            }
        }
        return {height,width}
    }

    useEffect(() => {
        window.addEventListener('orientationchange',() => {
            onCropperReady();
        })

        return () => {
            window.removeEventListener('orientationchange',() => {
                onCropperReady();
            })
        }
    },[])
    const fitImageInCropper = () => {
        const cropper = reactCropper;
        var ratio = 1;
        const option = props.data[0] || {};
        var cropBoxData = cropper.getCropBoxData(),
            cropBoxRatio = cropBoxData.height / cropBoxData.width,
            canvasData = cropper.getCanvasData(),
            canvasRatio = canvasData.naturalHeight / canvasData.naturalWidth,
            adjstRatio = 0.8; 
        let containerData = cropper.getContainerData();
        let isLargerImage = canvasData.height > canvasData.width ? (canvasData.height >= containerData.height * 0.8) && 'height' : (canvasData.width >= containerData.width * 0.9) && 'width'
        const aspectRatio = cropper.canvasData.aspectRatio;
            const dimensionConst = isLargerImage == 'width' ? containerData.width * adjstRatio : containerData.height * adjstRatio;
            let dataToSend = {}
            let res = fitInScreen(cropBoxData.height,cropBoxData.width,containerData,aspectRatio);
            dataToSend.height = res.height;
            dataToSend.width = res.width;
            dataToSend.left = (containerData.width - dataToSend.width) / 2;
            dataToSend.top = (containerData.height - dataToSend.height) / 2;
            cropper.setCropBoxData(dataToSend)
            cropper.setCanvasData(dataToSend);
        if (cropBoxRatio < canvasRatio) {
            canvasData.width = cropBoxData.width;
            ratio = canvasData.width / canvasData.naturalWidth;
            canvasData.height = canvasData.naturalHeight * ratio;
        } else {
            canvasData.height = cropBoxData.height;
            ratio = canvasData.height / canvasData.naturalHeight;
            canvasData.width = canvasData.naturalWidth * ratio;
        }
        if(fixedCropBoxSize){
            var container = cropper.getContainerData();
            const imageWidth = option.imageWidth || imageHeightWidth.imageWidth;
            const imageHeight = option.imageHeight || imageHeightWidth.imageHeight;
            cropper.setCropBoxData({
                width: imageWidth,
                height: imageHeight,
                left: (container.width - imageWidth) / 2,
                top: (container.height - imageHeight) / 2
            })
        }
        cropper.zoomTo(ratio);
        zoomRatio.current = ratio;
        // updateZoomRatio(ratio);
    }
    const unmountCropper = () => {
        props.toggleEditOptions({
            show: false
        })
    }
    function setCropperBoxInCenter() {
        if (setCropBoxInCenter) {
            const option = props.data[0] || {};
            const cropper = reactCropper;
            var container = cropper.getContainerData();
            var cropBoxWidth = option.imageWidth || imageHeightWidth.width;
            var cropBoxHeight = option.imageHeight || imageHeightWidth.height;
            let canvasData = cropper.getCanvasData();
            const newCropBoxData = {
                width: cropBoxWidth,
                height: cropBoxHeight,
                left: (container.width - cropBoxWidth) / 2,
                top: (container.height - cropBoxHeight) / 2
            }
            cropper.setCropBoxData(newCropBoxData);
            let newCanvasData = cropper.getCanvasData();
            const aspectRatio = newCanvasData.width / newCanvasData.height;
            if(aspectRatio > 1){
                const diffTop = newCanvasData.top - newCropBoxData.top;
                newCanvasData.height = newCropBoxData.width / aspectRatio;
                newCanvasData.top = newCropBoxData.top + diffTop + (canvasData.height - newCanvasData.height)/2;
                newCanvasData = {
                    ...newCanvasData,
                    width:cropBoxWidth,
                    left:(container.width - cropBoxWidth) / 2
                }
            } else{
                const diffLeft = newCanvasData.left - newCropBoxData.left;
                newCanvasData.width = newCropBoxData.height * aspectRatio;
                newCanvasData.left = newCropBoxData.left + diffLeft + (canvasData.width - newCanvasData.width)/2;
                newCanvasData = {
                    ...newCanvasData,
                    height:cropBoxHeight,
                    top:(container.height - cropBoxHeight) / 2
                }
            }
            cropper.setCanvasData(newCanvasData);
        }
    }

    const setPopoverPosition = () => {
        const mintopPopoverPos = Math.min(0.2 * window.innerHeight);
        const minbottomPopoverPos = Math.max(0.2 * window.innerHeight);
        let top = reactCropper.getCropBoxData().top - 60;
        let bottom = window.innerHeight - (reactCropper.getCropBoxData().height + reactCropper.getCropBoxData().top + 60);
        if(top < 0){
            top = mintopPopoverPos;
        }
        if(bottom > window.innerHeight){
            bottom = minbottomPopoverPos;
        }
        setPopoverPos({
            top,bottom
        })
    };

    const onCropperReady = () => {
        const refInterval = setInterval(() => {
            if(reactCropper) {
                clearInterval(refInterval);
                if(props.data[0].src == src){
                    updateImageDimension();
                    setCropperData();
                }
        
                if(!prefWidth){
                    const imageData = reactCropper.getImageData();
                    prefWidth = imageData.naturalWidth;
                    prefHeight = imageData.naturalHeight;
                }
                toggleCropperReady(true);
                toggleLoader(false);
                if(!props.isMobile){
                    setPopoverPosition();
                } else {
                    dragBoxTouchPrevent();
                    cropBoxTouchPrevent();
                }
            }
        }, 10);
    }
    const dragBoxTouchPrevent = () => {
        if(!reactCropper.dragBox){
            return;
        }
        reactCropper.dragBox.addEventListener('touchstart', (e) => {
            e.preventDefault();
        })
    }
    const cropBoxTouchPrevent = () => {
        if(!reactCropper.cropBox){
            return;
        }
        reactCropper.cropBox.addEventListener('touchstart', (e) => {
            e.preventDefault();
        })
    }
    function setCropperData() {
        const cropper = reactCropper;
        const option = props.data[0];
        var shiftOffset = 0;
        var curCropBoxData = cropper.getCropBoxData();
        var imageData = cropper.getImageData();
        updateCropperHW({
            height: imageData.height,
            width: imageData.width
        })
        if (option.cropperData) {
            var currentCropperData = cropper.getData();
            option.cropperData.x = currentCropperData.x;
            option.cropperData.y = currentCropperData.y;
            cropper.setData(option.cropperData);
        }else{
            fitImageInCropper();
            const {naturalHeight,naturalWidth} = cropper.getCanvasData();
            updateCropperHW({
                height: naturalHeight,
                width: naturalWidth
            })
            return;
        }
        if (option.canvasData) {
            //to adjust left of cropper
            var curCanvasData = cropper.getCanvasData();
            var newCanvasData = option.canvasData;
            var widthDiff = newCanvasData.width - curCanvasData.width;
            var previousLeft = newCanvasData.left;
            newCanvasData.left = curCanvasData.left - widthDiff / 2;
            shiftOffset = previousLeft - newCanvasData.left;
            //to adjust top of cropper
            var newCropBoxData = option.cropBoxData;
            if (newCropBoxData) {
                var topAdjustFactor = newCropBoxData.top - curCropBoxData.top;
                newCanvasData.top -= topAdjustFactor;
            }
            cropper.setCanvasData(newCanvasData);
        }
        if (option.cropBoxData) {
            if(option.cropBoxData.height > 500){
                const cropBoxRatio = 500 / option.cropBoxData.height;
                option.cropBoxData.height = 500 * 0.8;
                option.cropBoxData.width = cropBoxRatio * option.cropBoxData.width * 0.8;
            }
            option.cropBoxData.left -= shiftOffset;
            option.cropBoxData.top = (cropper.getCropBoxData().top > 60 ? cropper.getCropBoxData().top : (option.cropBoxData.top - topAdjustFactor));
            cropper.setCropBoxData(option.cropBoxData);
        }
    }
    function updateImageDimension(){
        setTimeout(() => {
            const imageData = reactCropper.getImageData();
            updateImageHeightWidth({
                imageWidth: imageData.width && imageData.width.toFixed(2),
                imageHeight: imageData.height && imageData.height.toFixed(2),
                rotate: imageHeightWidth.rotate
            })
        },100);
    }
    const cropImage = (e) => {
        e.stopPropagation();
        if(reactCropper){
            saveImageData()
        }
    }

    function saveImageData() {
        toggleLoader(true);
        const cropper = reactCropper;
        const curCropperData = props.data[0];
        // let copyCropperData = cropperData[index];
        const dataObj = {
            imagesrc: cropper.url,
            extension: extension,
            uploadFrom: uploadFrom,
            file : file
        }
        let canvasData = cropper.getCanvasData(),
            cropBoxData = cropper.getCropBoxData();
        const getExistingData = cropper.getData();
        cropper.setData({ ...getExistingData, height: cropperHW.height, width: cropperHW.width });

        if(cropBoxData && (cropBoxData.top < canvasData.top || cropBoxData.left < canvasData.left || cropBoxData.top + cropBoxData.height > canvasData.top + canvasData.height || cropBoxData.left + cropBoxData.width > canvasData.left + canvasData.width)){
            dataObj.extension = "png";
        }

        dataObj.image = cropper.image; // image element
        if(!/^https?:\/\//.test(cropper.url || "")){ // check whether its actually base64Url
            dataObj.relativeBase64Url = cropper.url; // actal base 64 url image
            dataObj.extension = cropper.url.split(';')[0].split('/')[1];
        }
        if(cropperHW.width < 450 || cropperHW.height < 450) {
            toggleLoader(false)
            props.showToastMessage({
				showToastMessage: true,
				message: 'Cropped Image Size is Too Small To Display Online. Please Increase Image Dimensions To At Least 450 x 450 Pixels',
				type: 'info',
				duration: 5000
			});
            return;
        }
        let file = null;
        if(!imageHeightWidth.rotate && !isInteracted) {
            toggleLoader(false);
            unmountCropper();
            return;
        }
        cropper.getCroppedCanvas().toBlob(async (blob) => {
            file = await new File([blob],'cropped-img.jpg',{type: 'image/'+dataObj.extension})
            let imageUrl = props.productData.imageUrlArr ? [...props.productData.imageUrlArr] : [];
            let productData = props.productData;
            onFileSelUpload({
                target: {files:[file]}},{
                    productId: productData.productId,
                    imageUrlArr: productData.imageUrlArr || [],
                    updateProductMedia: payload => {
                        if(props.uploadProps?.isVariant) {
                            productData = props.variantData[props.uploadProps.variantIndex];
                            imageUrl = imageUrl.length ? imageUrl : [...productData.imageUrlArr];
                            productData = {...productData,imageUrlArr: props.uploadProps.onFileUpload(payload).imageUrlArr};
                        }else if(props.fromListing) {
                            let values = props.uploadProps.onFileUpload(payload);
                            productData = {...productData,...values};
                        }else {
                            props.updateProductMedia({
                                ...payload,
                                ignoreSave: true,
                                isAddEditProduct: true
                            })
                        }
                        if(payload?.imageUrl?.imgURL) {
                            const timer = setInterval(() => {
                                if(imageUrl.length != productData.imageUrlArr.length && productData.imageUrlArr[productData.imageUrlArr.length - 1].imgURL) {
                                    clearInterval(timer)
                                    if(props.uploadProps?.isVariant || props.fromListing) {
                                        props.uploadProps.deleteImage(props.selectedImageIndex,true,true);
                                    }else{
                                        imageUrl = [...productData.imageUrlArr];
                                        imageUrl[props.selectedImageIndex] = imageUrl.pop();
                                        props.deleteProductImage({
                                            productId: productData.productId,
                                            imageUrlArr: imageUrl,
                                            ignoreSave: true,
                                            isAddEditPage: true
                                        })
                                    }
                                    setTimeout(() => {
                                        toggleLoader(false);
                                        unmountCropper()
                                    }, 300);
                                }
                            }, 200);
                        }
                    }
                })
            })
    }
    function getCropperBtnMarkup(){
        const markup = [
            !props.isMobile && getImageData()
        ];

        items.forEach((value, index) => {
            if(value.hide){
                return null;
            }
            markup.push(
                <div className={`cropper-btn ${value.key}`}
                    onClick={event => {
                            event && event.stopPropagation();
                            // this.closePopup(event);
                            value.onClick(event,value);
                        }
                    }
                    key={value.key}
                >
                    <span className={`item-icon ${value.iconClass}`}>{value.btnText}</span>
                    <span className={`display-text`}>{value.hoverText}</span>
                </div>
            );
        });
        return markup;
    }

    const getWidthHeightMarkup = () => {
        return (
            <div className='mobile-popover'>
                {`Width: ${Math.trunc(cropperHW.width)} Px | Height: ${Math.trunc(cropperHW.height)} Px`}
            </div>
        )
    }
    
    const getImageData = () => {
        return (
            <div
                className="cropper-btn set-height-width"
                key="image-data"
                onClick = {e => e.stopPropagation()}
            >
                <div
                    className="align-pop"
                >
                    <span
                        className="height-width-span"
                    >
                        W: {
                            Math.trunc(cropperHW.width)
                        }
                    </span>
                    <span
                        class = "height-width-span"
                    >
                        H: {Math.trunc(cropperHW.height)}
                    </span>
                </div>
            </div>
        )

    }
    const setCropMove = () => {
        let cropBoxData = reactCropper.getCropBoxData();
        updatedInteraction(true);
        const tmpCanvasData = reactCropper.canvasData
        const scaleRatio = (((tmpCanvasData.height - tmpCanvasData.naturalHeight) / tmpCanvasData.naturalHeight) + 1)
        const finalImgH = cropBoxData.height / scaleRatio
        const finalImgW = cropBoxData.width / scaleRatio
        updateCropperHW({
            height: finalImgH,
            width: finalImgW
        })
    }
    const imagePath = uploadFrom == 'system' ? src : getImagePath(src,"","library",true);
    return (

        <React.Fragment>
        {showLoader ? (
            <Loader
                className="display-block image-cropper-loader" // fixed this way because zindex was unnecc increased to 10000 by Arik
            />
        ) : null }
        {imagePath ?
            <div
                className = {`react-image-cropper image-cropper ${props.hasGlassFooter ? 'ubl-footer' : ''}`}
                onClick = {(e) => {
                    e.stopPropagation();
                }}
            >
                { props.isMobile ? (
                    <SliderHeader
                        heading={showCropper ? 'Crop' :'Edit Image'}
                        leftIcons={[
                            {
                                className: 'icon-HDRback',
                                onClick: () => {
                                    if(showCropper) {
                                        let {width,height,left,top} = reactCropper.getCanvasData();
                                        updateCroppedImage({
                                            ...croppedImage,
                                            image: croppedImage.newImage,
                                            newImage: ''
                                        })
                                        reactCropper.setCropBoxData({
                                            height,width,left,top
                                        })
                                        toggleCropper(false);
                                        return;
                                    }
                                    unmountCropper()
                                }
                            }
                        ]}
                        rightIcons={[
                            {
                                label: 'Save',
                                isText: true,
                                onClick: (e) => {
                                    if(showCropper) {
                                        let image = reactCropper.getCroppedCanvas().toDataURL();
                                        let cropperPos = reactCropper.getCropBoxData();
                                        reactCropper.setCropBoxData(reactCropper.getCanvasData());
                                        let oldImage = reactCropper.getCroppedCanvas().toDataURL();
                                        rotateDeg = 0;
                                        updateCroppedImage({...croppedImage,image,oldImage, Pos: {...cropperPos}, cnvsPos: {...reactCropper.getCanvasData()}});
                                        updatedInteraction(true);
                                        toggleCropper(false);
                                        return;
                                    }
                                    cropImage(e)
                                },
                                className: 'text-blue'
                            }
                        ]}
                        hasBorder={false}
                    />
                ) : null}
               {<Cropper
                    initialAspectRatio={imageHeightWidth.width / imageHeightWidth.height}
                    center
                    cropBoxMovable={true}
                    cropmove={() => {
                        setCropMove();
                    }}
                    cropBoxResizable
                    className={`cropper-div ${!showCropper? 'hide-cropper':''}`}
                    dragMode='none'
                    guides
                    ref = {instance => {
                        setTimeout(() => {
                            reactCropper = instance.cropper
                        }, 10);
                    }}
                    rotatable
                    ready={onCropperReady}
                    minCropBoxHeight={70}
                    minCropBoxWidth={70}
                    responsive
                    scalable
                    zoomTo={zoomRatio.current}
                    src={croppedImage?.image || imagePath}
                    toggleDragModeOnDblclick={false}
                    zoomOnWheel={showCropper}
                    zoomOnTouch={showCropper}
                    zoomable={showCropper}
                    viewMode={1}
                    checkCrossOrigin={false}
                    checkOrientation={false}
                />}
                {isCropperReady ? (
                    <div
                        className={`react-cropper-toolbar fade in show ${props.isMobile ? 'footer-btn' : 'popover'}`}
                        style={{
                            top: window.innerHeight * 0.05 //popoverPos.top
                        }}
                    >
                        <div
                            className="popover-content cropper-toolbar"
                        >

                                <div
                                    className={`btn-markup ${showCropper && props.isMobile ? 'mob-popover' : ''}`}
                                >
                                    {!(showCropper && props.isMobile) ? getCropperBtnMarkup(): getWidthHeightMarkup()}
                                </div> 
                            {!props.isMobile ? <div
                                className="btn-parent"
                            >
                                <div
                                    className= "cropper-btn save primary-btn-color"
                                    onClick={(e) => cropImage(e)}
                                >
                                    <span
                                        className="save-btn-text"
                                    >
                                        Save
                                    </span>
                                </div>
                            </div> : null}
                            { !props.isMobile ? (
                                <div
                                    className="cropper-btn close-btn"
                                    onClick={() => unmountCropper()}
                                >
                                    <span
                                        className="item-icon icon-HDRcross"
                                    />
                                </div>
                            ) : null}
                        </div>
                    </div>
                ) : null }
            </div>
            : null
        }
    </React.Fragment>
    )
}

export default connect(null,{
    deleteProductImage,
    toggleEditOptions, 
    updateProductMedia,
    showToastMessage: toastMessageActions.showMessage
})(ImageCropper);
